import $ from 'jquery';
import { init_product_add_to_cart } from "../product-add-to-cart";
import { IntercompanyOrders } from "./product-header";

const productPageBody = $( '.product-detail' );

const getEgosData = ( pshNumber ) => {
	$.ajax( {
		type: "POST",
		url: psh_vars.rest_route.psh_catalog_egos_data,
		data: {
			pshNumber: pshNumber,
		},
		complete: function () {
			$( '#on-load' ).remove();
		},
		success: function (data) {
			if ( data.success ) {
				// load all html
				$( '#available-stock' ).html(data.table_html);
				$( '#product-detail__actions' ).after( data.actions_html );
				$( '#total_stock_html' ).html(data.total_stock_html);

				// load all js for html
				init_product_add_to_cart();
				new IntercompanyOrders();
			} else {
				$( '#stock-and-price-error' ).show();
			}
		},
		error: function() {
			$( '#stock-and-price-error' ).show();
		}
	} );

}

$( document ).ready(function() {
	// Only get the egos data on product detail page when logged in
	if ( productPageBody.length === 0 || productPageBody.data( 'pshNumber' ).length === 0 ) {
		$( '#on-load' ).remove();
		$( '#stock-and-price-error' ).show();
		return false;
	}

	getEgosData( productPageBody.data( 'pshNumber' ) );
});